import { useMemo } from "react";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getAllOrders, Filters } from "./api";

import { ORDER_QUERY_KEY } from "@entities/order";
import { useAuthenticationContext } from "@app/auth/use-authentication-context";
import { PageOfPreorder } from "@api/structures/PageOfPreorder";

export interface Options<F = Omit<Filters, "companyId">> extends Partial<
  UseQueryOptions<PageOfPreorder>
> {
  filters: F;
}

export const useOrdersQuery = (options: Options) => {
  const { activeCompany } = useAuthenticationContext();

  const filters = useMemo<Filters>(
    () => ({
      companyId: activeCompany?.id ?? -1,
      ...options.filters,
    }),
    [options.filters, activeCompany],
  );

  return useQuery({
    enabled: !!activeCompany,
    queryKey: [ORDER_QUERY_KEY, filters ?? {}],
    queryFn: () => getAllOrders(filters ?? {}),
    ...options,
  });
};
